import { FecMappingReviewStatus } from '../enums/fecMappingReviewStatus'
import { FecPushStatus } from '../enums/fecPushStatus'

/** Whether a domain (journals, accounts or third parties) still has to be confirmed, or confirmed again after a failed push. */
export const isFecConfirmationIncomplete = (
  mappingStatus: FecMappingReviewStatus | null,
  pushStatus: FecPushStatus | null,
): boolean =>
  mappingStatus !== FecMappingReviewStatus.Confirmed ||
  pushStatus === FecPushStatus.PushFailed ||
  pushStatus === FecPushStatus.NotPushed
